export default function checkEmailValidation(email: string): boolean {
  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@~!#$*&%^"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // NOSONAR
  return EMAIL_REGEX.test(email);
}
